import React from 'react';

import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Divider,
  DialogActions,
  Grid,
  Button,
} from '@material-ui/core';
import classes from './index.module.scss';
import RonadIcons from '../../iconComponent';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  cancelLabel?: string;
  submitLabel?: string;
  onSubmit: () => void;
  loading: boolean;
};

function ConfirmModal({
  open,
  onClose,
  children,
  cancelLabel,
  submitLabel,
  onSubmit,
  loading = false,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogContent>
        <div
          style={{
            position: 'absolute',
            left: '5px',
            top: '5px',
            zIndex: 10,
          }}
        >
          <IconButton aria-label="close" onClick={onClose}>
            <RonadIcons name="times"  size={0.8}/>
          </IconButton>
        </div>

        <div className={classes.cancelTitle}>{children}</div>
        {/* <Divider style={{marginBottom: '10px'}} /> */}
      </DialogContent>
      <DialogActions className={classes.actionsBox}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            spacing={2}
            style={{padding: '5px 0', marginBottom: '8px'}}
          >
            <Button
              style={{margin: '7px', padding: '5px 30px'}}
              onClick={onClose}
              variant="outlined"
              color="primary"
              size="medium"
              id="cancel"
            >
              {cancelLabel}
            </Button>
            <Button
              style={{margin: '7px'}}
              variant="contained"
              onClick={onSubmit}
              size="medium"
              color="primary"
              id="saveBtn"
              disabled={loading}
            >
              {submitLabel}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

ConfirmModal.defaultProps = {
  cancelLabel: 'انصراف',
  submitLabel: 'تایید',
};

export default ConfirmModal;
